import VipService from '../../../service/vip';
import ReduxTrialVip from "../../../store/actionreducers/trialVip";
import _ from "lodash";

const Action = {
    GET_CONTACTS: '[TRIAL VIP APP] GET CONTACTS',
    SET_SEARCH_TEXT: '[TRIAL VIP APP] SET SEARCH TEXT',
    SET_SIDEBAR_SEARCH_TEXT: '[TRIAL VIP APP] SET SIDEBAR SEARCH TEXT',
    TOGGLE_IN_SELECTED_CONTACTS: '[TRIAL VIP APP] TOGGLE IN SELECTED CONTACTS',
    SELECT_ALL_CONTACTS: '[TRIAL VIP APP] SELECT ALL CONTACTS',
    DESELECT_ALL_CONTACTS: '[TRIAL VIP APP] DESELECT ALL CONTACTS',
    OPEN_NEW_CONTACT_DIALOG: '[TRIAL VIP APP] OPEN NEW CONTACT DIALOG',
    CLOSE_NEW_CONTACT_DIALOG: '[TRIAL VIP APP] CLOSE NEW CONTACT DIALOG',
    OPEN_EDIT_CONTACT_DIALOG: '[TRIAL VIP APP] OPEN EDIT CONTACT DIALOG',
    CLOSE_EDIT_CONTACT_DIALOG: '[TRIAL VIP APP] CLOSE EDIT CONTACT DIALOG',
    ADD_CONTACT: '[TRIAL VIP APP] ADD CONTACT',
    UPDATE_CONTACT: '[TRIAL VIP APP] UPDATE CONTACT',
    REMOVE_CONTACT: '[TRIAL VIP APP] REMOVE CONTACT',
    REMOVE_CONTACTS: '[TRIAL VIP APP] REMOVE CONTACTS',
    TOGGLE_STARRED_CONTACT: '[TRIAL VIP APP] TOGGLE STARRED CONTACT',
    TOGGLE_STARRED_CONTACTS: '[TRIAL VIP APP] TOGGLE STARRED CONTACTS',
    SET_CONTACTS_STARRED: '[TRIAL VIP APP] SET CONTACTS STARRED ',
    OPEN_ALERT_DIALOG: '[TRIAL VIP APP] OPEN ALERT DIALOG',
    CLOSE_ALERT_DIALOG: '[TRIAL VIP APP] CLOSE ALERT DIALOG',
};

const ActionCreator = {

    getContacts(routeParams) {
        return async (dispatch) => {

            const data = await VipService.listTrialVips(); // routeParams = { id :'all' }

            return dispatch({
                type: Action.GET_CONTACTS,
                payload: data,
                routeParams
            });

        };
    },
    setSearchText(event) {
        return {
            type: Action.SET_SEARCH_TEXT,
            searchText: event.target.value
        }
    },
    setSidebarSearchText(event) {
        return {
            type: Action.SET_SIDEBAR_SEARCH_TEXT,
            sidebarSearchText: event.target.value
        }
    },
    closeNewContactDialog() {
        return {
            type: Action.CLOSE_NEW_CONTACT_DIALOG
        }
    },
    openNewContactDialog(data) {
        return {type: Action.OPEN_NEW_CONTACT_DIALOG, data};
    },
    openEditContactDialog(data) {
        return {type: Action.OPEN_EDIT_CONTACT_DIALOG, data};
    },
    closeEditContactDialog() {
        return {type: Action.CLOSE_EDIT_CONTACT_DIALOG};
    },
    addContact() {
        return async (dispatch) => {
            return dispatch(ActionCreator.openAlertDialog({msg: '請問要產生新的試用會員嗎?'}));
        };
    },
    openAlertDialog({msg, vipId}) {
        return {type: Action.OPEN_ALERT_DIALOG, msg, vipId};
    },
    closeAlertDialog() {
        return {type: Action.CLOSE_ALERT_DIALOG};
    },
    confirmAddContact() {
        return async (dispatch) => {
            const data = await VipService.addTrialVip(); // routeParams = { id :'all' }
            await dispatch(ReduxTrialVip.ActionCreator.getTrialVip(data.id)); // 取得新增的試用會員資訊
            await dispatch(ReduxTrialVip.ActionCreator.getTrialVips()); // 取得所有試用會員資訊
            dispatch(ActionCreator.getContacts({id: 'all'})); // 更新 contactsList 的資訊
            dispatch(ActionCreator.openEditContactDialog(data)); // 開啟  contactsDialog
            return dispatch(ActionCreator.closeAlertDialog()); // 關閉 alert dialog
        };
    },
    confirmDisableVip(vipId) {
        return async (dispatch) => {
            await VipService.disableTrialVip(vipId);
            dispatch(ActionCreator.getContacts({id: 'all'})); // 更新 contactsList 的資訊
            dispatch(ActionCreator.closeAlertDialog()); // 關閉 alert dialog
            return dispatch(ActionCreator.closeEditContactDialog()); // 關閉 contactsDialog
        };
    },
    openRemoveContactDialog(vipId) {
        return async (dispatch) => {
            const data = await VipService.findTrialVipById(vipId);
            dispatch(ActionCreator.openEditContactDialog(data)); // 開啟  contactsDialog
            return dispatch(ActionCreator.openAlertDialog({msg: '請問您要停用此測試帳號嗎?', vipId}));
        };
    },
    updateContact(vip) {
        console.log('updateContact , vip=', vip);
        return async (dispatch) => {
            await VipService.updateTrialVip(vip); // routeParams = { id :'all' }
            dispatch(ActionCreator.getContacts({id: 'all'})); // 更新 contactsList 的資訊
            return dispatch(ActionCreator.closeEditContactDialog()); // 開啟  contactsDialog
        };
    },
};

const initialState = {
    entities: [],
    searchText: '',
    sidebarSearchText: '',
    selectedContactIds: [],
    routeParams: {},
    contactDialog: {
        type: 'new',
        props: {
            open: false
        },
        data: null
    },
    alertDialog: {
        props: {
            open: false
        },
        data: ''
    }
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.GET_CONTACTS: {
            return {
                ...state,
                entities: _.keyBy(action.payload, 'id'),
                routeParams: action.routeParams
            };
        }
        case Action.SET_SEARCH_TEXT: {
            return {
                ...state,
                searchText: action.searchText
            };
        }
        case Action.SET_SIDEBAR_SEARCH_TEXT: {
            return {
                ...state,
                sidebarSearchText: action.sidebarSearchText
            };
        }
        case Action.TOGGLE_IN_SELECTED_CONTACTS: {

            const contactId = action.contactId;

            let selectedContactIds = [...state.selectedContactIds];

            if (selectedContactIds.find(id => id === contactId) !== undefined) {
                selectedContactIds = selectedContactIds.filter(id => id !== contactId);
            }
            else {
                selectedContactIds = [...selectedContactIds, contactId];
            }

            return {
                ...state,
                selectedContactIds: selectedContactIds
            };
        }
        case Action.SELECT_ALL_CONTACTS: {
            const arr = Object.keys(state.entities).map(k => state.entities[k]);

            const selectedContactIds = arr.map(contact => contact.id);

            return {
                ...state,
                selectedContactIds: selectedContactIds
            };
        }
        case Action.DESELECT_ALL_CONTACTS: {
            return {
                ...state,
                selectedContactIds: []
            };
        }
        case Action.OPEN_NEW_CONTACT_DIALOG: {
            return {
                ...state,
                contactDialog: {
                    type: 'new',
                    props: {
                        open: true
                    },
                    data: null
                }
            };
        }
        case Action.CLOSE_NEW_CONTACT_DIALOG: {
            return {
                ...state,
                contactDialog: {
                    type: 'new',
                    props: {
                        open: false
                    },
                    data: null
                }
            };
        }
        case Action.OPEN_EDIT_CONTACT_DIALOG: {
            return {
                ...state,
                contactDialog: {
                    type: 'edit',
                    props: {
                        open: true
                    },
                    data: action.data
                }
            };
        }
        case Action.CLOSE_EDIT_CONTACT_DIALOG: {
            return {
                ...state,
                contactDialog: {
                    type: 'edit',
                    props: {
                        open: false
                    },
                    data: null
                }
            };
        }
        case Action.OPEN_ALERT_DIALOG: {
            return {
                ...state,
                alertDialog: {
                    props: {
                        open: true
                    },
                    msg: action.msg || '請問要產生新的試用會員嗎?',
                    vipId: action.vipId
                }
            };
        }
        case Action.CLOSE_ALERT_DIALOG: {
            return {
                ...state,
                alertDialog: {
                    props: {
                        open: false
                    },
                    msg: ''
                }
            };
        }
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/trial_vip/contacts.js